import React from 'react';
import PropTypes from 'prop-types';
import {
  VictoryChart,
  VictoryTheme,
  VictoryScatter,
  VictoryBrushContainer,
  VictoryTooltip,
  VictoryArea,
  VictoryBar,
  VictoryLine,
  VictoryLabel,
  VictoryAxis,
  Point,
  Text
} from 'victory';
import { Headline, Body1 } from '../FontStyles';
import StatsBox from './StatsBox';
import { Flex, Box } from 'rebass';
import Styled from 'styled-components';
import Button from './Button';
import baseTheme from '../../themes/baseTheme';
import danielData from '../../data/TidepoolExportNew.json';

const ChartContainer = Styled(Flex)`
max-width: 1440px;

.VictoryContainer {
max-height: 140px;
}


`;

const ChartBox = Styled(Box)`

}
`;

const CarbCircle = Styled(Text)`
width: 10px;
font-size: 6px;
border-radius: 100%;
background-color: papayawhip;
border: 1px solid blue;


`;

class NormalPoint extends React.PureComponent {
  render() {
    const { datum } = this.props;
    let pointColor;

    if (datum.value > 13.85) {
      pointColor = '#8c65d6';
    } else if ((datum.value < 13.85) & (datum.value > 10)) {
      pointColor = '#bb9ae7';
    } else if ((datum.value < 10) & (datum.value > 3.9)) {
      pointColor = '#76d3a6';
    } else if ((datum.value < 3.9) & (datum.value > 3)) {
      pointColor = '#ff8b7c';
    } else {
      pointColor = '#fb5951';
    }

    if (this.props.symbol === 'triangleDown') {
      pointColor = '#f2994a';
    }

    return <Point {...this.props} style={{ fill: pointColor, zIndex: 99 }} />;
  }
}
class BaconPoint extends React.Component {
  render() {
    const { x, y, datum } = this.props;

    return (
      <CarbCircle x={x} y={y} fontSize={6}>
        {(datum.name ? datum.name : '🥓') + datum.carbAmount}
      </CarbCircle>
    );
  }
}
class Graph extends React.Component {
  constructor() {
    super();
    this.state = {
      beginning: new Date('2019-06-20T07:00:00Z'),
      end: new Date('2019-06-21T07:00:00Z'),
      chartStart: '2019-06-20T07:00:00Z',
      chartEnd: '2019-06-21T07:00:00Z'
    };
    this.handleSelection = this.handleSelection.bind(this);
    this.getStats = this.getStats.bind(this);
    this.calcAggStats = this.calcAggStats.bind(this);
    this.iobCalcExponential = this.iobCalcExponential.bind(this);
    this.iobCalcBilinear = this.iobCalcBilinear.bind(this);
    this.getPercentageLeftExp = this.getPercentageLeftExp.bind(this);
    this.nextDay = this.nextDay.bind(this);
    this.prevDay = this.prevDay.bind(this);
  }

  handleSelection = (domain, props) => {
    // console.log('ran');
    // console.log(domain);
    // console.log(props);
    this.setState({ beginning: domain.x[0], end: domain.x[1] });
  };

  prevDay = () => {
    console.log('ran');
    const chartStartNew = (new Date(this.state.chartStart) - 1).toISOString();
    console.log(chartStartNew);
    const chartEndNew = (new Date(this.state.chartEnd) - 1).toISOString();
    console.log(chartEndNew);
    this.setState({
      beginning: this.state.beginning - 1,
      end: this.state.end - 1,
      chartStart: chartStartNew,
      chartEnd: chartEndNew
    });
  };

  nextDay = () => {
    const chartStartNew = (new Date(this.state.chartStart) - 1).toISOString();
    console.log(chartStartNew);
    const chartEndNew = (new Date(this.state.chartEnd) - 1).toISOString();
    console.log(chartEndNew);
    this.setState({
      beginning: this.state.beginning - 1,
      end: this.state.end - 1,
      chartStart: chartStartNew,
      chartEnd: chartEndNew
    });
  };

  getPercentageLeftExp = minsAgo => {
    let peak = 75;

    var end = 300; // end of insulin activity, in minutes

    var tau = (peak * (1 - peak / end)) / (1 - (2 * peak) / end); // time constant of exponential decay
    var a = (2 * tau) / end; // rise time factor
    var S = 1 / (1 - a + (1 + a) * Math.exp(-end / tau)); // auxiliary scale factor

    const percentageLeft =
      1 -
      S * (1 - a) * ((Math.pow(minsAgo, 2) / (tau * end * (1 - a)) - minsAgo / tau - 1) * Math.exp(-minsAgo / tau) + 1);

    return percentageLeft;
  };

  iobCalcExponential = (treatment, minsAgo, dia, peak) => {
    peak = 75;

    var end = 300; // end of insulin activity, in minutes

    var activityContrib = 0;
    var iobContrib = 0;

    if (minsAgo < end) {
      // Formula source: https://github.com/LoopKit/Loop/issues/388#issuecomment-317938473
      // Mapping of original source variable names to those used here:
      //   td = end
      //   tp = peak
      //   t  = minsAgo
      var tau = (peak * (1 - peak / end)) / (1 - (2 * peak) / end); // time constant of exponential decay
      var a = (2 * tau) / end; // rise time factor
      var S = 1 / (1 - a + (1 + a) * Math.exp(-end / tau)); // auxiliary scale factor

      activityContrib =
        treatment.insulin * (S / Math.pow(tau, 2)) * minsAgo * (1 - minsAgo / end) * Math.exp(-minsAgo / tau);
      iobContrib =
        (1 - S) *
        (1 - a) *
        ((Math.pow(minsAgo, 2) / (tau * end * (1 - a)) - minsAgo / tau - 1) * Math.exp(-minsAgo / tau) + 1);
      //console.error('DIA: ' + dia + ' minsAgo: ' + minsAgo + ' end: ' + end + ' peak: ' + peak + ' tau: ' + tau + ' a: ' + a + ' S: ' + S + ' activityContrib: ' + activityContrib + ' iobContrib: ' + iobContrib);
    }

    var results = {
      activityContrib: activityContrib,
      iobContrib: iobContrib
    };

    return results.iobContrib;
  };

  iobCalcBilinear = (treatment, minsAgo, dia) => {
    const default_dia = 3.0; // assumed duration of insulin activity, in hours
    const peak = 75; // assumed peak insulin activity, in minutes
    const end = 180; // assumed end of insulin activity, in minutes

    // Scale minsAgo by the ratio of the default dia / the user's dia
    // so the calculations for activityContrib and iobContrib work for
    // other dia values (while using the constants specified above)
    var timeScalar = default_dia / dia;
    var scaled_minsAgo = timeScalar * minsAgo;

    var activityContrib = 0;
    var iobContrib = 0;

    // Calc percent of insulin activity at peak, and slopes up to and down from peak
    // Based on area of triangle, because area under the insulin action "curve" must sum to 1
    // (length * height) / 2 = area of triangle (1), therefore height (activityPeak) = 2 / length (which in this case is dia, in minutes)
    // activityPeak scales based on user's dia even though peak and end remain fixed
    var activityPeak = 2 / (dia * 60);
    var slopeUp = activityPeak / peak;
    var slopeDown = -1 * (activityPeak / (end - peak));

    if (scaled_minsAgo < peak) {
      activityContrib = treatment.insulin * (slopeUp * scaled_minsAgo);

      var x1 = scaled_minsAgo / 5 + 1; // scaled minutes since bolus, pre-peak; divided by 5 to work with coefficients estimated based on 5 minute increments
      iobContrib = treatment.insulin * (-0.001852 * x1 * x1 + 0.001852 * x1 + 1.0);
    } else if (scaled_minsAgo < end) {
      var minsPastPeak = scaled_minsAgo - peak;
      activityContrib = treatment.insulin * (activityPeak + slopeDown * minsPastPeak);

      var x2 = (scaled_minsAgo - peak) / 5; // scaled minutes past peak; divided by 5 to work with coefficients estimated based on 5 minute increments
      iobContrib = treatment.insulin * (0.001323 * x2 * x2 + -0.054233 * x2 + 0.55556);
    }

    var results = {
      activityContrib: activityContrib,
      iobContrib: iobContrib
    };

    return results;
  };

  calcAggStats = () => {};
  getStats = bgData => {
    let veryHighBg = 0;
    let highBg = 0;
    let targetBg = 0;
    let lowBg = 0;
    let veryLowBg = 0;

    bgData.map(point => {
      if (point.value > 13.85) {
        veryHighBg = veryHighBg + 1;
      } else if ((point.value < 13.85) & (point.value > 10)) {
        highBg = highBg + 1;
      } else if ((point.value < 10) & (point.value > 3.9)) {
        targetBg = targetBg + 1;
      } else if ((point.value < 3.9) & (point.value > 3)) {
        lowBg = lowBg + 1;
      } else {
        veryLowBg = veryLowBg + 1;
      }
      if (this.props.symbol === 'triangleDown') {
        veryLowBg += 1;
      }
      return point;
    });

    const statsObject = [
      {
        name: 'Very Low',
        total: veryLowBg,
        percentOfSegment: Math.round((100 * veryLowBg) / bgData.length),
        fill: '#fb5951'
      },
      {
        name: 'Low',
        total: lowBg,
        percentOfSegment: Math.round((100 * lowBg) / bgData.length),
        fill: 'rgb(255, 139, 124)'
      },
      {
        name: 'Target',
        total: targetBg,
        percentOfSegment: Math.round((100 * targetBg) / bgData.length),
        fill: '#76d3a6'
      },
      { name: 'High', total: highBg, percentOfSegment: Math.round((100 * highBg) / bgData.length), fill: '#bb9ae7' },
      {
        name: 'Very High',
        total: veryHighBg,
        percentOfSegment: Math.round((100 * veryHighBg) / bgData.length),
        fill: '#8c65d6'
      }
    ];

    const statsObject2 = {
      veryHighBg: {
        name: 'Very High',
        total: veryHighBg,
        percentOfSegment: Math.round((100 * veryHighBg) / bgData.length)
      },
      HighBg: { name: 'High', total: highBg, percentOfSegment: Math.round((100 * highBg) / bgData.length) },
      targetBg: { name: 'Target', total: targetBg, percentOfSegment: Math.round((100 * targetBg) / bgData.length) },
      lowBg: { name: 'Low', total: lowBg, percentOfSegment: Math.round((100 * lowBg) / bgData.length) },
      veryLowBg: { name: 'Very Low', total: veryLowBg, percentOfSegment: Math.round((100 * veryLowBg) / bgData.length) }
    };
    return statsObject;
  };

  render() {
    const realData = danielData.filter(x => {
      return x.time < this.state.chartEnd && x.time > this.state.chartStart;
    });
    const bgData = realData.filter(x => x.value);
    const basalDataFixed = realData
      .filter(x => x.rate || x.rate === 0)
      .map(x => {
        x.date = new Date(x.time);
        return x;
      });
    const bolusData = realData.filter(x => x.normal);
    const carbData = realData.filter(x => x.type === 'food');

    const bolusDataFixed = bolusData.map(x => {
      x.date = new Date(x.time);
      return x;
    });

    const bgDataFixed = bgData.map(x => {
      x.date = new Date(x.time);
      x.targetTop = 110 / 18.018;
      x.targetBottom = 100 / 18.018;
      return x;
    });

    // Get Carb data needed
    const carbDataFixed = carbData.map(x => {
      x.date = new Date(x.time);
      x.carbAmount = x.nutrition.carbohydrate.net;
      return x;
    });

    const carbDateArray = carbDataFixed.map(x => {
      return { carbAmount: x.carbAmount, carbTime: x.date };
    });

    const cobData = realData.map(x => {
      x.newCarbData = carbDateArray.map(carbEntry => {
        const carbTimeSince = (x.date - carbEntry.carbTime) / 60000 > 0 ? (x.date - carbEntry.carbTime) / 60000 : 0;
        return {
          carbAmount: carbEntry.carbAmount,
          carbTimeSince: carbTimeSince
        };
      });
      return x;
    });

    const currentCob = cobData.map(x => {
      x.carbArray = x.newCarbData.map(z => {
        let currentCarbAmount;
        const percentOfCarbsLeft = Math.max((180 - z.carbTimeSince) / 180, 0);

        if (z.carbTimeSince > 0 && z.carbTimeSince < 180) {
          currentCarbAmount = z.carbAmount * percentOfCarbsLeft;
        } else {
          currentCarbAmount = 0;
        }
        z.currentCarbAmount = currentCarbAmount;
        z.percentOfCarbsLeft = percentOfCarbsLeft;

        return currentCarbAmount;
      });
      x.finalCob = x.carbArray.reduce((a, b) => a + b);
      return x;
    });

    //Get insulin data and calcuations
    const insulinEvents = realData.filter(x => x.rate || x.rate === 0 || x.normal);
    const basalEvents = realData.filter(x => x.rate || x.rate === 0);

    const insulinDateArray = insulinEvents.map(x => {
      if (x.normal) {
        return {
          date: x.date,
          dateFormatted: x.date.toLocaleString(),
          bolusAmount: x.normal,
          basalRateChange: 0,
          duration: x.duration,
          amountDelivered: x.normal,
          expectedBasalAmount: 0
        };
      } else {
        return {
          date: x.date,
          dateFormatted: x.date.toLocaleString(),
          bolusAmount: 0,
          basalRateChange: x.rate,
          duration: x.duration / 60000,
          shouldEnd: x.duration,
          amountDelivered: ((x.duration / 60000) * x.rate) / 60,
          expectedBasalAmount: x.suppressed
            ? (x.suppressed.rate * x.duration) / (60000 * 60)
            : (1 * x.duration) / (60000 * 60)
        };
      }
    });
    const iobData = realData.map(x => {
      x.newIobData = insulinDateArray.map(insulinEvent => {
        const insulinEventTimeSince =
          (x.date - insulinEvent.date) / 60000 > 0 ? (x.date - insulinEvent.date) / 60000 : 0;
        return {
          amountDelivered: insulinEvent.amountDelivered,
          insulinEventTimeSince: insulinEventTimeSince,
          expectedBasalAmount: insulinEvent.expectedBasalAmount
        };
      });
      return x;
    });

    const currentIob = iobData.map(x => {
      x.iobArray = x.newIobData.map(z => {
        let currentIobAmount;

        const percentOfInsulinLeft = Math.max((300 - z.insulinEventTimeSince) / 180, 0);

        if (z.insulinEventTimeSince > 0 && z.insulinEventTimeSince < 300) {
          currentIobAmount = z.amountDelivered * percentOfInsulinLeft - z.expectedBasalAmount;
        } else {
          currentIobAmount = 0;
        }
        z.currentIobAmount = currentIobAmount;
        z.percentOfInsulinLeft = percentOfInsulinLeft;
        return currentIobAmount;
      });
      x.finalIob = x.iobArray.reduce((a, b) => a + b);
      return x;
    });

    const currentIobExp = iobData.map(x => {
      x.iobArrayExp = x.newIobData.map(z => {
        let currentIobAmount;

        if (z.insulinEventTimeSince > 0 && z.insulinEventTimeSince < 300) {
          currentIobAmount =
            z.amountDelivered * this.getPercentageLeftExp(z.insulinEventTimeSince) - z.expectedBasalAmount;
        } else {
          currentIobAmount = 0;
        }
        z.currentIobAmount = currentIobAmount;
        z.percentOfInsulinLeft = this.getPercentageLeftExp(z.insulinEventTimeSince);
        return currentIobAmount;
      });
      x.finalIobExp = x.iobArrayExp.reduce((a, b) => a + b);
      return x;
    });

    console.log(currentIobExp);

    const fullBasalRates = realData.map(x => {
      const events = insulinDateArray.filter(insulinEvent => insulinEvent.date > x.date);
      if (events.length > 0) {
        x.activeEvent = events[events.length - 1].basalRateChange - 1;
      } else x.activeEvent = 1;
      //   x.activeEvents = events[0].basalRateChange;
      return x;
    });

    let newBgDataFixed = bgDataFixed.filter(x => x.date > this.state.beginning && x.date < this.state.end);
    const timeInRangeStats = this.getStats(newBgDataFixed);

    var avg = Array.from(
      newBgDataFixed.reduce(
        (acc, obj) =>
          Object.keys(obj).reduce(
            (acc, key) => (typeof obj[key] == 'number' ? acc.set(key, (acc.get(key) || []).concat(obj[key])) : acc),
            acc
          ),
        new Map()
      ),
      ([name, values]) => ({ name, average: values.reduce((a, b) => a + b) / values.length })
    );

    return (
      <ChartContainer flexWrap="wrap" justifyContent="center" alignItems="flex-start" width={1}>
        <Flex flexWrap="wrap" mb={-50} justifyContent="flex-start" width={1}>
          <Flex width={0.7} justifyContent="center" flewWrap="wrap" alignItems="flex-start">
            <Flex width={1}>
              <Body1>Daily View</Body1>
            </Flex>
          </Flex>
        </Flex>
        <Flex width={1} alignItems="flex-start" justifyContent="center">
          <Flex width={0.7} alignItems="flex-start" flexWrap="wrap">
            <VictoryChart
              theme={VictoryTheme.material}
              scale={{ x: 'time' }}
              gridComponent={<Point />}
              containerComponent={
                <VictoryBrushContainer
                  brushDimension="x"
                  brushStyle={{ zIndex: -1, stroke: 'transparent', fill: 'black', fillOpacity: 0.03 }}
                  brushDomain={
                    this.state.beginning
                      ? { x: [new Date(this.state.beginning), new Date(this.state.end)] }
                      : { x: 'all' }
                  }
                  onBrushDomainChange={(domain, props) => this.handleSelection(domain, props)}
                />
              }
              height={200}
              width={800}
              domainPadding={10}
            >
              <VictoryArea
                data={bgDataFixed}
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                x="date"
                y="targetTop"
                style={{
                  data: {
                    strokeWidth: 0.5,
                    fillOpacity: 0.2,
                    fill: '#BCECFA',
                    zIndex: -2
                  }
                }}
              />
              <VictoryArea
                data={bgDataFixed}
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                x="date"
                y="targetBottom"
                style={{
                  data: {
                    strokeWidth: 0.5,
                    stroke: '#BCECFA',
                    fillOpacity: 1,
                    fill: '#ffffff',
                    zIndex: -1
                  }
                }}
              />
              <VictoryScatter
                data={bgData}
                x="date"
                size={1}
                y="value"
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                labels={d => `Bg: ${Math.round(d.value * 18.018018)}  Time: ${d.date.toLocaleString()}`}
                labelComponent={<VictoryTooltip />}
                dataComponent={<NormalPoint />}
                style={{ data: { fill: (d, active) => (active ? 'tomato' : 'black') } }}
              />
              <VictoryAxis
                dependentAxis
                tickValues={[3.9, 10, 13.85]}
                tickFormat={t => Math.round(t * 18.018018)}
                domain={[0, 15]}
              ></VictoryAxis>
            </VictoryChart>

            <VictoryChart
              scale={{ x: 'time' }}
              height={200}
              width={800}
              domainPadding={10}
              theme={VictoryTheme.material}
              containerComponent={
                <VictoryBrushContainer
                  brushDimension="x"
                  brushDomain={{ x: [new Date(this.state.beginning), new Date(this.state.end)] }}
                  onBrushDomainChange={domain => this.handleSelection(domain)}
                  brushStyle={{ zIndex: -1, stroke: 'transparent', fill: 'black', fillOpacity: 0.03 }}
                />
              }
            >
              <VictoryBar
                labels={d => d.rate}
                labelComponent={<VictoryTooltip />}
                data={basalDataFixed}
                x="date"
                y="rate"
                barRatio={1}
                style={{ data: { stroke: '#f2994a', fill: '#FFD382', strokeWidth: 0.5 } }}
              />

              <VictoryAxis
                dependentAxis
                style={{
                  axisLabel: { padding: 40 }
                }}
              />
              <VictoryLine
                data={basalDataFixed.filter(x => x.suppressed && (x.suppressed.rate || x.supressed.rate === 0))}
                x="date"
                y={d => d.suppressed.rate}
                style={{ data: { stroke: baseTheme.colors.lightPurple, strokeWidth: 1 } }}
              />

              <VictoryScatter
                data={bolusDataFixed}
                x="date"
                y="normal"
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                labels={d => `Time: ${d.time} | Bolus Amount: ${d.normal}`}
                labelComponent={<VictoryTooltip />}
                height={200}
                dataComponent={<NormalPoint symbol="triangleDown" />}
              />
            </VictoryChart>

            <VictoryChart
              scale={{ x: 'time' }}
              height={200}
              width={800}
              domainPadding={10}
              theme={VictoryTheme.material}
              containerComponent={
                <VictoryBrushContainer
                  brushDimension="x"
                  brushDomain={{ x: [new Date(this.state.beginning), new Date(this.state.end)] }}
                  onBrushDomainChange={domain => this.handleSelection(domain)}
                  brushStyle={{ zIndex: -1, stroke: 'transparent', fill: 'black', fillOpacity: 0.03 }}
                />
              }
            >
              <VictoryAxis
                dependentAxis
                style={{
                  axisLabel: { padding: 40 }
                }}
              />

              <VictoryBar
                data={fullBasalRates}
                x="date"
                y="activeEvent"
                labels={d => ` currentBasal: ${d.activeEvent}`}
                labelComponent={<VictoryTooltip />}
                domain={{ y: [-2, 5], x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                style={{
                  data: {
                    strokeWidth: 0.1,
                    fill: '#FFD382',
                    zIndex: -2,
                    stroke: '#ffd382',
                    padding: 0,
                    margin: 0
                  }
                }}
              />
              <VictoryScatter
                data={bolusDataFixed}
                x="date"
                y="normal"
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                labels={d => `Time: ${d.time} | Bolus Amount: ${d.normal}`}
                labelComponent={<VictoryTooltip />}
                height={200}
                dataComponent={<NormalPoint symbol="triangleDown" />}
              />
            </VictoryChart>
            <VictoryChart
              scale={{ x: 'time' }}
              theme={VictoryTheme.material}
              height={200}
              width={800}
              domainPadding={10}
              containerComponent={
                <VictoryBrushContainer
                  brushDimension="x"
                  brushDomain={{ x: [new Date(this.state.beginning), new Date(this.state.end)] }}
                  onBrushDomainChange={domain => this.handleSelection(domain)}
                  brushStyle={{ zIndex: -1, stroke: 'transparent', fill: 'black', fillOpacity: 0.03 }}
                />
              }
            >
              <VictoryAxis
                dependentAxis
                style={{
                  axisLabel: { padding: 40 }
                }}
              />
              <VictoryArea
                data={currentIob}
                scale={{ x: 'time' }}
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                x="date"
                y="finalIob"
                style={{
                  data: {
                    strokeWidth: 0.5,
                    fillOpacity: 0.3,
                    fill: '#FFD382',
                    zIndex: -2
                  }
                }}
              />
              <VictoryAxis
                tickLabelComponent={<VictoryLabel offsetY={100} />}
                style={{ axisLabel: { padding: 30 } }}
              ></VictoryAxis>
            </VictoryChart>
            {/*  Commented out Exp Model
            <VictoryChart
              scale={{ x: 'time' }}
              theme={VictoryTheme.material}
              height={200}
              width={800}
              domainPadding={10}
              containerComponent={
                <VictoryBrushContainer
                  brushDimension="x"
                  brushDomain={{ x: [new Date(this.state.beginning), new Date(this.state.end)] }}
                  onBrushDomainChange={domain => this.handleSelection(domain)}
                  brushStyle={{ zIndex: -1, stroke: 'transparent', fill: 'black', fillOpacity: 0.03 }}
                />
              }
            >
              <VictoryAxis
                dependentAxis
                style={{
                  axisLabel: { padding: 40 }
                }}
              />
              <VictoryArea
                data={currentIobExp}
                scale={{ x: 'time' }}
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                x="date"
                y="finalIobExp"
                style={{
                  data: {
                    strokeWidth: 0.5,
                    fillOpacity: 0.3,
                    fill: baseTheme.colors.green,
                    zIndex: -2
                  }
                }}
              />
              <VictoryAxis
                tickLabelComponent={<VictoryLabel offsetY={100} />}
                style={{ axisLabel: { padding: 30 } }}
              ></VictoryAxis>
            </VictoryChart>
             */}
            <VictoryChart
              scale={{ x: 'time' }}
              theme={VictoryTheme.material}
              height={200}
              width={800}
              domainPadding={10}
              containerComponent={
                <VictoryBrushContainer
                  brushDimension="x"
                  brushDomain={{ x: [new Date(this.state.beginning), new Date(this.state.end)] }}
                  onBrushDomainChange={domain => this.handleSelection(domain)}
                  brushStyle={{ zIndex: -1, stroke: 'transparent', fill: 'black', fillOpacity: 0.03 }}
                />
              }
            >
              <VictoryAxis
                dependentAxis
                style={{
                  axisLabel: { padding: 40 }
                }}
              />
              <VictoryArea
                data={currentCob}
                scale={{ x: 'time' }}
                domain={{ x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                x="date"
                y="finalCob"
                style={{
                  data: {
                    strokeWidth: 0.5,
                    fillOpacity: 0.3,
                    fill: baseTheme.colors.green,
                    zIndex: -2
                  }
                }}
              />

              <VictoryScatter
                data={carbDataFixed}
                x="date"
                y="carbAmount"
                domain={{ y: [0, 110], x: [new Date(this.state.chartStart), new Date(this.state.chartEnd)] }}
                dataComponent={<BaconPoint />}
                labels={d => `Type: ${d.name} | Time: ${d.time}`}
                labelComponent={<VictoryTooltip />}
                d
              />
              <VictoryAxis
                tickLabelComponent={<VictoryLabel offsetY={100} />}
                style={{ axisLabel: { padding: 30 } }}
              ></VictoryAxis>
            </VictoryChart>
          </Flex>
          <Flex width={0.3}>
            <StatsBox
              data={timeInRangeStats}
              otherData={realData}
              currentRangeStart={this.state.beginning}
              currentRangeEnd={this.state.end}
              totalBasalRateAtTarget={this.state.totalBasalRateAtTarget}
              totalInsulinDelivered={this.state.totalInsulinDelivered}
              avgBg={
                avg[1]
                  ? avg[0].name === 'value'
                    ? Math.round(avg[0].average * 18.018018)
                    : Math.round(avg[1].average * 18.018018)
                  : ''
              }
            />
          </Flex>
        </Flex>
      </ChartContainer>
    );
  }
}

Graph.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
};

Graph.defaultProps = {
  text: '',
  className: ''
};

/** @component */
export default Graph;
